import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import FilterSelect from "../../../components/select/filterSelect";
import moment from "moment";
import { MenuItem } from "@mui/material";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { useTranslation } from "react-i18next";
import { FiberManualRecord, RemoveRedEyeOutlined } from "@mui/icons-material";
import CustomStatus from "../../../components/chip/CustomStatus";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import DropdownButton from "../../../components/button/DropdownButton";
import { OnlineLeaveSubmissionApi } from "../../../api/online-leave-submission/online-leave-submission.api";
import { dateTimeToView, dateToView } from "../../../utils/date.utils";
import {
  allStatusLeaveOnline,
  handleColorStatusUtil,
  handleTextStatusUtil,
} from "../../../utils/statusLeaveRequest";
import ModalQuotaHoliday from "./components/modal/ModalQuotaHoliday";
import { mockLeaveTypeHoliday } from "../../../utils/mockData";
import { settingLeavePeriodApi } from "../../../api/setting-leave-period/setting-leave-period.api";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import { LeaveReportQuery, ReportApi } from "../../../api/report/Report.api";
import { saveAs } from "file-saver";
import { RootState } from "../../../store/store";
import { checkPermission } from "../../../utils/app.utils";

type Props = {};

const OnlineLeaveSubmission: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);


  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('OnlineLeaveSubmission', permission);

  const [dataOnlineLeaveSubmission, setDataOnlineLeaveRequest] = useState([]);
  const [dataLeaveType, setDataLeaveType] = useState<any[]>([]);
  const [inputValueSearch, setInputValueSearch] = useState({
    leave_type: "",
    status: "all",
  });


  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };
  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const [isShowModalQuotaHoliday, setIsShowModalQuotaHoliday] =
    useState<boolean>(false);

  const [dataStatus, setDataStatus] = useState(allStatusLeaveOnline);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(
    dataOnlineLeaveSubmission && dataOnlineLeaveSubmission.length
  );
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const [dataPeriodLeaveDay, setDataPeriodLeaveDay] = useState<any>({});

  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getLeaveRequestOnlines = async () => {
    let query: any = {
      leave_status: inputValueSearch.status,
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      id_leave_type: inputValueSearch.leave_type,
      leave_start_date: startDate,
      leave_end_date: endDate,
    };

    const res =
      await OnlineLeaveSubmissionApi.getRequestLeaveSubmissionByEmployee(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      setTotalItems(res.data?.data?.meta?.totalItems || 0);

      const newData = data.data.items.map((item: any) => {
        return {
          id_leave: item.id_leave,
          leave_start_date: item.leave_start_date ?? null,
          leave_end_date: item.leave_end_date ?? null,
          leave_status: item.leave_status,
          created_date: item.created_date,
          id_employee: item.employee.id_employee,
          title: item.employee.title,
          first_name: item.employee.first_name,
          last_name: item.employee.last_name,
          employee_no: item.employee.employee_no,
          start_date: item.employee.work?.start_date ?? null,
          position_name: item.employee.work?.position?.position_name ?? "-",
          leave_type_name: item.leave_type?.leave_type_name,
        };
      });

      setDataOnlineLeaveRequest(newData);
    } else {
      setDataOnlineLeaveRequest([]);
    }
  };


  const handleDownloadReport = async (report_type: "pdf" | "excel") => {
    let query: LeaveReportQuery = {
      page: page,
      limit: pageLimit,
      type_file: report_type
    };
    if (startDate) query.leave_start_date = startDate;
    if (endDate) query.leave_end_date = endDate;
    if (inputValueSearch.status) query.leave_status = inputValueSearch.status
    dispatch(setLoading());
    await ReportApi.reportLeaveListEmployee(query).then((res) => {
      if (res.status < 300) {
        const response = res.data;
        const type_file = report_type === 'pdf' ? 'application/pdf' : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        const blob_file = new Blob([response], {
          type: type_file
        })
        saveAs(blob_file, 'รายงานระบบส่งใบลาออนไลน์' + "_" + moment().format("LL"))
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }

  useEffect(() => {
    getLeaveRequestOnlines();
  }, [page, pageLimit, sortBy, sortType, startDate, endDate, inputValueSearch]);

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "fullname",
      width: 50,
      disablePadding: false,
      align: "start",
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.FULLNAME"),
    },
    {
      id: "indentification_number",
      disablePadding: false,
      width: 75,
      align: "center",
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.IDENTIFICATION_NUMBER"),
    },
    {
      id: "position",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.POSITION"),
    },
    {
      id: "leave_type",
      disablePadding: false,
      align: "center",
      width: 40,
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.LEAVE_TYPE"),
    },
    {
      id: "request_period",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.LEAVE_REQUEST_PERIOD"),
    },
    {
      id: "date_request_submission",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.DATE_REQUEST_SUBMISSION"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("ONLINE_LEAVE_SUBMISSION.COLUMN.STATUS"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_leave,
      leave_start_date,
      leave_end_date,
      leave_status,
      created_date,
      first_name,
      last_name,
      employee_no,
      position_name,
      leave_type_name,
    } = objData;

    const objRenderData = {
      key: id_leave,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${first_name} ${last_name}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: employee_no || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: position_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: leave_type_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label:
            dateToView(leave_start_date, false) +
            "-" +
            dateToView(leave_end_date, false) || " - ",
        },
        {
          option: "TEXT",
          align: "center",
          label: created_date ? dateTimeToView(created_date, false) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <CustomStatus
              label={handleTextStatusUtil(leave_status)}
              type="outlined"
              color={handleColorStatusUtil(leave_status)}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              {checkPermit.isUpdate && (
                <RemoveRedEyeOutlined
                  onClick={() => {
                    navigate(
                      routeName.cms.OnlineLeaveSubmission + `/detail/${id_leave}`
                    );
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getLeavePeroid = async () => {
    const currentYearBuddhist = new Date().getFullYear()

    let query: any = {
      leave_period: currentYearBuddhist,
    };
    const res = await settingLeavePeriodApi.getAllLeavePeriod(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      // console.log(data.data.items,'data.data.items')
      const newData = data.data.items.map((item: any) => {
        return {
          id_leave_period: item.id_leave_period,
          year: item.leave_period,
          start_date: item.leave_period_start,
          end_date: item.leave_period_end,
          passing_year: item.passing_year,
          user_update: item?.modified
            ? item?.modified?.title +
            " " +
            item?.modified?.first_name +
            " " +
            item?.modified?.last_name
            : "-",
          last_update: item.modified_date,
          status: item.status,
        };
      });

      setDataPeriodLeaveDay(newData[0] ?? {});
    } else {
      setDataPeriodLeaveDay({});
    }
  };

  const getLeaveType = async () => {
    let query: any = {
      page: 1,
      limit: 100,
    };
    const res = await leaveTypeApi.getAllLeaveType(query);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
    } else {
      setDataLeaveType([]);
    }
  };

  useEffect(() => {
    getLeavePeroid();
    getLeaveType();
  }, []);

  return (
    <div>
      <ModalQuotaHoliday
        is_update={false}
        is_all={false}
        data={mockLeaveTypeHoliday}
        setIsOpenModal={(isOpen: boolean) => setIsShowModalQuotaHoliday(isOpen)}
        isOpenModal={isShowModalQuotaHoliday}
        idEmployee={profile ? [profile.id_employee] : []}
        period_id={dataPeriodLeaveDay.id_leave_period ?? 0}
      />

      <ContentHeading
        title={"ONLINE_LEAVE_SUBMISSION.TOPIC.ONLINE_LEAVE_SUBMISSION_SYSTEM"} // ระบบส่งใบลาออนไลน์
        detail="ONLINE_LEAVE_SUBMISSION.TOPIC.SELECT_ITEM_YOU_WANT"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-2 sm:col-span-12">
          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </article>

        <article className="w-full col-span-12 md:col-span-6 lg:col-span-2 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.leave_type ?? ""}
            labelId="courses-id"
            selectId="courses-select-id"
            options={[
              {
                id_leave_type: "",
                leave_type_name: "รูปแบบการลาทังหมด",
              },
              ...dataLeaveType,
            ].map((list, index) => (
              <MenuItem value={list.id_leave_type} key={index + 1}>
                {list.leave_type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("leave_type", e.target.value)
            }
          />
        </article>
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-2 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.status ?? ""}
            labelId="status-id"
            selectId="status-select-id"
            options={dataStatus.map((list, index) => (
              <MenuItem value={list.id} key={index + 1}>
                {list.name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("status", e.target.value)
            }
          />
        </article>
        <article
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
          className="w-full col-span-12 md:col-span-12 lg:col-span-6 sm:col-span-12"
        >
          <div>
            <DropdownButton
              buttonName={t(
                "ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.DOWNLOAD_FILE"
              )}
              menuItems={[
                {
                  id: 1,
                  name: "pdf",
                  onClick: () => {
                    handleDownloadReport('pdf')
                  },
                },
                {
                  id: 2, name: "excel", onClick: () => {
                    handleDownloadReport('excel')
                  }
                },
              ]}
              fullWidth={true}
            />
          </div>

          <div>
            {checkPermit.isView && (
              <ButtonPrimary
                onClick={() => {
                  setIsShowModalQuotaHoliday(true);
                }}
                buttonName={t(
                  "ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.LEAVE_RIGHTS"
                )}
                btnProps={{
                  margin: "5px",
                }}
              />
            )}
            {checkPermit.isCreated && (
              <ButtonPrimary
                onClick={() => {
                  navigate(routeName.cms.OnlineLeaveSubmissionCreate);
                }}
                buttonName={t(
                  "ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.SUBMISSION_LEAVE_REQUEST_ONLINE"
                )}
                mode="next"
              />
            )}

          </div>
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataOnlineLeaveSubmission &&
            dataOnlineLeaveSubmission.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default OnlineLeaveSubmission;
